import {
  IconButton,
  InputAdornment,
  OutlinedInput,
  TextField,
} from "@mui/material";
import { BoxContainer, LoginCard, LoginImg } from "./styles";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { FormEvent, useState } from "react";
import { useAuth } from "../../context/auth-context";
import { useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";

export function Login() {
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword((s) => !s);
  };

  async function handleLogin(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setLoading(true);
    const username = event.currentTarget.username.value;
    const password = event.currentTarget.password.value;

    const res = await signIn({
      login: username,
      password,
    });

    if (res.data.success) {
      navigate("/");
    }

    setLoading(false);
  }

  const usernameOnStorage = localStorage.getItem("@username");

  const username = usernameOnStorage;

  return (
    <BoxContainer>
      <LoginCard onSubmit={handleLogin}>
        <LoginImg src={`/sync-login-logo.svg`} />
        <TextField
          name="username"
          sx={{
            width: "300px",
          }}
          type="text"
          id="username"
          label={!username ? "Usuário" : ""}
          variant="outlined"
          defaultValue={username}
        />
        <OutlinedInput
          name="password"
          id="outlined-adornment-password"
          sx={{
            width: "300px",
          }}
          placeholder="Senha"
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                edge="end"
                onClick={handleClickShowPassword}
                size="large"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
          type={showPassword ? "text" : "password"}
        />
        <LoadingButton
          loading={loading}
          type="submit"
          sx={{
            width: "100%",
            fontWeight: "bold",
          }}
          variant="outlined"
        >
          Login
        </LoadingButton>
      </LoginCard>
    </BoxContainer>
  );
}
